import { render, staticRenderFns } from "./ConnectWechat.vue?vue&type=template&id=d1a8ba06&"
import script from "./ConnectWechat.vue?vue&type=script&lang=js&"
export * from "./ConnectWechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports